define('UnitOfMeasure.ProductViews.Price.View', [
    'Profile.Model',
    'ProductViews.Price.View',
    'UnitOfMeasure.QuantityPricing.Collection',
    'UnitsOfMeasure.Helper',
    'Profile.Model',
    'Store.Item.Stock.Helper',
    'underscore'
], function UnitOfMeasureProductViewsPriceView(
    ProfileModel,
    ProductViewsPriceView,
    UnitOfMeasureQuantityPricingCollection,
    UnitsOfMeasureHelper,
    Profile,
    StoreItemStockHelper,
    _
) {
    'use strict';

    _.extend(ProductViewsPriceView.prototype, {
        initialize: _.wrap(ProductViewsPriceView.prototype.initialize, function initialize(fn) {
            fn.apply(this, _.toArray(arguments).slice(1));
            this.isPackItem = UnitsOfMeasureHelper.isPackItem(this.model.get && this.model.get('item') ?
                this.model.get('item') : this.model);
            if (this.options && this.options.isPdp && this.isPackItem) {
                this.retailPricingCollection = new UnitOfMeasureQuantityPricingCollection();
                this.listenTo(this.retailPricingCollection, 'sync', this.render);
                if (this.model.get('item') && this.model.get('item').get('internalid')) {
                    this.retailPricingCollection.fetch({
                        data: {
                            parent: this.model.get('item').get('internalid'),
                            store: ProfileModel.getInstance().get('store').get('internalid') || '1'
                        }
                    });
                }
            }
        }),
        showPrice: function showPrice(item) {
            var finalStore = (item && item.store) || Profile.getInstance().get('store');
            if (!item) {
                return '';
            }
            // eslint-disable-next-line no-underscore-dangle
            return !StoreItemStockHelper._notSoldInStoreMessage(item, finalStore);
        },
        getContext: _.wrap(ProductViewsPriceView.prototype.getContext, function fnGetContext(fn) {
            var ret = fn.apply(this, _.toArray(arguments).slice(1));
            var profile = ProfileModel.getInstance();
            var store = profile.get('store');
            var mrspPriceLevel = store.get('msrpPriceLevelSSKey');
            var oldMrspPriceLevel = store.get('msrpPriceLevelSSKey');
            var retailPrice;
            var columnPrice;
            var column;
            var item = this.model.get('item') || this.model;
            var isSearchSpring = item && item.get('isSearchSpring');
            var itemPrice = parseFloat(item && item.get('_price'));
            var quantity = this.model.get('quantity');


            if (this.options.isPdp && this.isPackItem && this.retailPricingCollection && this.retailPricingCollection.length > 1) {
                for (column = this.retailPricingCollection.length - 1; column >= 1 && !retailPrice; column--) {
                    columnPrice = this.retailPricingCollection.at(column);
                    if ((!columnPrice.get('maximumquantity') || parseInt(columnPrice.get('maximumquantity'), 10) >= quantity) &&
                        (!columnPrice.get('minimumquantity') || parseInt(columnPrice.get('minimumquantity'), 10) <= quantity)) {
                        retailPrice = columnPrice;
                    }
                }
                if (retailPrice && retailPrice.get('price')) {
                    if (parseFloat(retailPrice.get('price'), 10) > parseFloat((ret.price), 10)) {
                        ret.showComparePrice = true;

                        ret.comparePriceFormatted = retailPrice.get('price_formatted');

                        ret.comparePrice = retailPrice.get('price');
                    } else {
                        ret.showComparePrice = false;
                    }
                }
            } else if (this.options.isPdp && this.isPackItem) {
                ret.showComparePrice = false;
            } else if (isSearchSpring) {
                if (this.isPackItem && isSearchSpring) {
                    mrspPriceLevel = mrspPriceLevel.replace('_0', '_1');
                }
                ret.showComparePrice = item.get(mrspPriceLevel) ?
                    itemPrice < parseFloat(item.get(mrspPriceLevel)) : item.get(oldMrspPriceLevel) && itemPrice < parseFloat(item.get(oldMrspPriceLevel));
            }
            ret.showPrice = ret.model && ret.model.get('item') ? this.showPrice(ret.model.get('item')) : this.showPrice(ret.model);
            return ret;
        })
    });
});
